export enum EGoogleTagAnalyticsKeys {
  VIEW_HOME = 'view_home',
  HOME_CURRENT_TAB = 'home_current_tab',
  HOME_OLD_TAB = 'home_old_tab',
  MATCH_DETAILS_CURRENT_TAB = 'match_details_current_tab',
  MATCH_DETAILS_ODL_TAB = 'match_details_odl_tab',
  MATCH_DETAILS_MATCH_CURRENT_TAB = 'match_details_match_current_tab',
  MATCH_DETAILS_MATCH_ODL_TAB = 'match_details_match_odl_tab',
  VIEW_COMPETITION = 'view_competition',
  VIEW_HEAD_TO_HEAD = 'view_head_to_head',
  VIEW_STATS = 'view_stats',
  VIEW_MATCH = 'view_match',
  VIEW_TEAM = 'view_team',
  // VIEW_PLAYER = 'view_player',
  // VIEW_LIVE_MATCHES = 'view_live_matches',
  ADD_COMPETITION_FAVORITE = 'add_competition_favorite',
  REMOVE_COMPETITION_FAVORITE = 'remove_competition_favorite',
  ADD_MATCH_FAVORITES = 'add_match_favorites',
  REMOVE_MATCH_FAVORITES = 'remove_match_favorites',
  // SHARE_MATCH = 'share_match',
  ADD_TEAM_FAVORITE = 'add_team_favorite',
  REMOVE_TEAM_FAVORITE = 'remove_team_favorite',
  // SHARE_TEAM = 'share_team',
  PAGE_VIEW_CONTEXT = 'page_view_context',
  CLICK_PROMO_BANNER = 'click_promo_banner',
  VIEW_PROMO_BANNER = 'view_promo_banner',
  // SEARCH_PERFORMED = 'search_performed',
  // TAB_CHANGE = 'tab_change',
  // SCROLL_DEPTH = 'scroll_depth',
  // TIME_ON_PAGE = 'time_on_page',
  // INTERACTION_START = 'interaction_start',
}
